import { useNavigate } from 'react-router'
import { Button } from '@mui/material'

import leakPinsAnimation from '../../animations/leak-pins.json'
import BackButton from '../../components/back-button'
import ScreenContainer from '../../components/screen'
import SensorActivationAnimation from '../../components/sensor-activation-animation'
import SensorActivationFooter from '../../components/sensor-activation-footer'
import { useActivationContext } from '../../providers/activation-provider'

const LeakPins = () => {
  const navigate = useNavigate()
  const { activationLocationState } = useActivationContext()

  return (
    <ScreenContainer
      useDarkBackground={true}
      headerProps={{
        leftIcon: <BackButton />,
        useDarkBackground: true,
        progress: 65,
      }}
      footerSpacing={148}
    >
      <SensorActivationAnimation animation={leakPinsAnimation} loop={true} />
      <SensorActivationFooter
        primaryButton={
          <Button variant="contained" color="secondary" disableElevation onClick={() => navigate('/placement-suggestions', { state: activationLocationState })}>
            See how to place
          </Button>
        }
      />
    </ScreenContainer>
  )
}

export default LeakPins
